// Agreement content locales (Phase 5A).
//
// Centralized here (under i18n/, exempt from the locale-format CI guard) so
// feature + mock code never hardcodes 'en-US' / 'tr-TR' literals. These are
// AGREEMENT-content locale identifiers (which language of a policy the signer
// reads/accepts), distinct from the Intl date/number format locales the guard
// polices. English is the controlling version; Türkçe is a translation of the
// same agreement. No governing state is encoded here — a locale is a language.

export const AGREEMENT_EN = 'en-US'
export const AGREEMENT_TR = 'tr-TR'

export const SUPPORTED_AGREEMENT_LOCALES: string[] = [AGREEMENT_EN, AGREEMENT_TR]
export const CONTROLLING_AGREEMENT_LOCALE = AGREEMENT_EN

// Short label (language switcher buttons).
export function agreementLocaleShortLabel(locale: string): string {
  if (locale === AGREEMENT_EN) return 'English'
  if (locale === AGREEMENT_TR) return 'Türkçe'
  return locale
}

// Long label incl. the locale tag (authoring tabs).
export function agreementLocaleLongLabel(locale: string): string {
  if (locale === AGREEMENT_EN) return 'English (en-US)'
  if (locale === AGREEMENT_TR) return 'Türkçe (tr-TR)'
  return locale
}

// Map the UI language preference ('en' | 'tr') to the agreement locale. The
// signing language is resolved from the account / UI preference — never IP or
// nationality.
export function uiToAgreementLocale(ui: string): string {
  return ui === 'tr' ? AGREEMENT_TR : AGREEMENT_EN
}
